<template>
  <div id="helpdesk_widget"/>
</template>

<script>
import createHelpdesk from './redmine'

export default {
  mounted() {
    createHelpdesk(
      'helpdesk_widget',
      this.buildRedmineUrl(),
      this.customLoad
    )
  },
  methods: {
    buildRedmineUrl() {
      const env = process.env.VUE_APP_ENV
      if (env === 'production')
        return 'https://redmine.platform.brobot.com.br'

      return `https://redmine-${env}.platform.brobot.com.br`
    },
    customLoad(redmineHelpdeskWidget) {
      const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim() || '#2a6b8f'

      redmineHelpdeskWidget.config({
        color: primaryColor,
        translation: {
          nameLabel: 'Nome',
          emailLabel: 'Email',
          descriptionLabel: 'Escreva sua solicitação aqui',
          createButtonLabel: 'Enviar',
          createSuccessDescription: 'Obrigado pela sua solicitação!',
          createErrorLabel: 'Ops! Algo deu errado, tente novamente mais tarde. Se o erro persistir, enviei um email diretamente para suporte@brobot.com.br',
          subjectLabel: 'Assunto',
          createSuccessLabel: 'Solicitação enviada com sucesso! Em breve um de nossos agentes entrará em contato com você.',
          attachmentLinkLabel: 'Anexar arquivo',
        },
        attachment: true,
        position: 'bottomLeft',
        title: '<h3>Estamos aqui para te ajudar!</h3><p>Preencha os campos abaixo com as informações que achar importante e nós cuidaremos do restante.</p><p>Quanto mais detalhes você providenciar, melhor poderemos atender sua solicitação. Vamos lá!</p>',
      })

      if (!redmineHelpdeskWidget.iframe)
        return

      redmineHelpdeskWidget.iframe.style.position = 'absolute'
      redmineHelpdeskWidget.iframe.style.top = '70px'
      redmineHelpdeskWidget.iframe.style.pointerEvents = 'none'
      redmineHelpdeskWidget.iframe.style.zIndex = '-1'

      redmineHelpdeskWidget.hide = function () {
        if (this.reload === true)
          this.reload_form()

        this.iframe.style.opacity = 0
        this.iframe.style.top = '70px'
        this.iframe.style.pointerEvents = 'none'
        this.iframe.style.zIndex = '-1'
        this.widget_button.style.borderRadius = '30px'
        this.widget_button.style.webkitTransform = ''
        this.widget_button.style.mozTransform = ''
        this.widget_button.style.msTransform = ''
        this.widget_button.style.oTransform = ''
      }

      redmineHelpdeskWidget.arrange_iframe = function () {
        const button_margin = this.margin + this.button_size

        if (this.full_screen)
          this.iframe.style.paddingTop = this.px(button_margin + (button_margin / 3))
        else
          this.iframe.style.minHeight = this.px(window.innerHeight - button_margin - 10)

        switch (this.configuration['position']) {
          case 'topLeft':
            this.iframe.style.top = this.full_screen ? this.px(-this.margin) : this.px(button_margin)
            this.iframe.style.left = this.full_screen ? this.px(-this.margin) : this.px(0)
            break
          case 'topRight':
            this.iframe.style.top = this.full_screen ? this.px(-this.margin) : this.px(button_margin)
            this.iframe.style.left = this.full_screen ? this.px(-window.innerWidth + button_margin) : this.px(-this.width + this.button_size)
            break
          case 'bottomLeft':
            this.iframe.style.top = this.px(-window.innerHeight + button_margin)
            this.iframe.style.left = this.full_screen ? this.px(-this.margin) : this.px(0)
            break
          case 'bottomRight':
            this.iframe.style.top = this.full_screen ? this.px(-window.innerHeight + button_margin) : this.px(-this.form.offsetHeight - this.margin * 2)
            this.iframe.style.left = this.full_screen ? this.px(-window.innerWidth + button_margin) : this.px(-this.width + this.button_size)
            break
          default:
            this.iframe.style.top = this.full_screen ? this.px(-window.innerHeight + button_margin) : this.px(-this.form.offsetHeight - this.margin * 2)
            this.iframe.style.left = this.full_screen ? this.px(-window.innerWidth + button_margin) : this.px(-this.width + this.button_size)
        }
        this.iframe.style.opacity = '1'
        this.iframe.style.pointerEvents = 'auto'
        this.iframe.style.zIndex = '9998'
      }
    }
  }
}

</script>

<style>
#helpdesk_widget {
  left: 40px !important;
  z-index: 9999 !important;
}

#helpdesk_widget iframe {
  pointer-events: none !important;
  z-index: -1 !important;
}

#helpdesk_widget iframe[style*="opacity: 1"] {
  pointer-events: auto !important;
  z-index: 9998 !important;
}

#widget_button {
  transition-property: all !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
</style>